import React from "react";
import {
  GrayBody,
  GrayCard,
  GrayHeader,
  HeaderButton,
  MobileButton,
  TableContainer,
  TableItem
} from "./style";
import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import styled from "styled-components";
import BadgeIcon from "components/badgeIcon";
import { useNavigate } from "react-router-dom";
import { GetUser } from "services/user/getUser";

const Profile = () => {
  const navigate = useNavigate();
  const Edit = () => {
    navigate("/settings/profile");
  };
  const UserData = GetUser();
  return (
    <GrayCard>
      <GrayHeader>
        <NameContainer>
          <BadgeIcon
            name={UserData?.name || ""}
            size="6.4"
            fontSize="2.4rem"
            bgColor={Colors.purple200}
            m_size="4.8"
          />
          <NameArtist>
            <Typography
              color={Colors.white100}
              size="2xl"
              weight="medium"
              mb="0.4"
              m_size="xl"
            >
              {UserData?.name}
            </Typography>
            <Typography color={Colors.grey500} m_size="s">
              {UserData?.artistProfiles?.length} Artist
              {UserData?.artistProfiles &&
                UserData?.artistProfiles?.length > 0 &&
                "s"}
            </Typography>
          </NameArtist>
        </NameContainer>
        <HeaderButton>
          <PrimaryButton
            onClick={Edit}
            text="Edit"
            fitContent
            iconPosition="right"
            iconSize="1.4"
            variant="border"
            textColor={Colors.white100}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M8.1794 2.53942L8.6428 2.07598C9.41065 1.30813 10.6556 1.30813 11.4234 2.07598C12.1913 2.84383 12.1913 4.08876 11.4234 4.85662L10.96 5.32005M8.1794 2.53942C8.1794 2.53942 8.2373 3.52423 9.10625 4.39318C9.97519 5.26212 10.96 5.32005 10.96 5.32005M8.1794 2.53942L3.91877 6.80003C3.63019 7.08863 3.4859 7.23288 3.36181 7.39198C3.21542 7.57968 3.08993 7.78273 2.98753 7.99758C2.90072 8.17973 2.8362 8.37333 2.70714 8.76048L2.16026 10.4011M10.96 5.32005L6.6994 9.58068C6.4108 9.86923 6.26655 10.0135 6.10745 10.1376C5.91976 10.284 5.7167 10.4095 5.50184 10.5119C5.3197 10.5987 5.12611 10.6632 4.73894 10.7923L3.09832 11.3392M2.16026 10.4011L2.02658 10.8022C1.96307 10.9927 2.01266 11.2027 2.15467 11.3448C2.29669 11.4868 2.50675 11.5364 2.69728 11.4729L3.09832 11.3392M2.16026 10.4011L3.09832 11.3392"
                  stroke="currentColor"
                  stroke-width="0.874999"
                />
              </svg>
            }
          />
        </HeaderButton>
      </GrayHeader>
      <GrayBody>
        <TableContainer>
          <TableItem>
            <Typography size="xl" color={Colors.grey100} weight="semibold">
              Full Name
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              {UserData?.name}
            </Typography>
          </TableItem>
          <TableItem>
            <Typography size="xl" color={Colors.grey100} weight="semibold">
              Email
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              {UserData?.email}
            </Typography>
          </TableItem>
          <TableItem>
            <Typography size="xl" color={Colors.grey100} weight="semibold">
              Phone Number
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              {UserData?.phoneNumber || "N/A"}
            </Typography>
          </TableItem>
          <TableItem>
            <Typography size="xl" color={Colors.grey100} weight="semibold">
              Country
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              {UserData?.country || "N/A"}
            </Typography>
          </TableItem>
        </TableContainer>
        <MobileButton>
          <PrimaryButton
            onClick={Edit}
            text="Edit"
            iconPosition="right"
            iconSize="1.4"
            variant="border"
            textColor={Colors.white100}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M8.1794 2.53942L8.6428 2.07598C9.41065 1.30813 10.6556 1.30813 11.4234 2.07598C12.1913 2.84383 12.1913 4.08876 11.4234 4.85662L10.96 5.32005M8.1794 2.53942C8.1794 2.53942 8.2373 3.52423 9.10625 4.39318C9.97519 5.26212 10.96 5.32005 10.96 5.32005M8.1794 2.53942L3.91877 6.80003C3.63019 7.08863 3.4859 7.23288 3.36181 7.39198C3.21542 7.57968 3.08993 7.78273 2.98753 7.99758C2.90072 8.17973 2.8362 8.37333 2.70714 8.76048L2.16026 10.4011M10.96 5.32005L6.6994 9.58068C6.4108 9.86923 6.26655 10.0135 6.10745 10.1376C5.91976 10.284 5.7167 10.4095 5.50184 10.5119C5.3197 10.5987 5.12611 10.6632 4.73894 10.7923L3.09832 11.3392M2.16026 10.4011L2.02658 10.8022C1.96307 10.9927 2.01266 11.2027 2.15467 11.3448C2.29669 11.4868 2.50675 11.5364 2.69728 11.4729L3.09832 11.3392M2.16026 10.4011L3.09832 11.3392"
                  stroke="currentColor"
                  stroke-width="0.874999"
                />
              </svg>
            }
          />
        </MobileButton>
      </GrayBody>
    </GrayCard>
  );
};

export default Profile;

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

const NameArtist = styled.div``;
